// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CoreXNav-cls1___3519981b585928cdec0{/*!*/}.CoreXNav-cls2__c06bd34203506ce48ee5{max-width:100vw;height:100%;border-bottom:1px solid #dddde2;border-bottom:1px solid var(--stroke-light, #dddde2);background:#fff;background:var(--background-white, #fff)}.CoreXNav-cls2__c06bd34203506ce48ee5.CoreXNav-inDevStyle__e96f80b85843a953b565{background-color:aqua}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "CoreXNav-cls1___3519981b585928cdec0",
	"cls2": "CoreXNav-cls2__c06bd34203506ce48ee5 CoreXNav-cls1___3519981b585928cdec0",
	"inDevStyle": "CoreXNav-inDevStyle__e96f80b85843a953b565"
};
export default ___CSS_LOADER_EXPORT___;
